export default "__VITE_PUBLIC_ASSET__6235501f__"